// extracted by mini-css-extract-plugin
module.exports = {"EmailCom":"EmailCom_EmailCom__q8WCY"};